import type { RouteLocationRaw } from "vue-router";

export interface NotificationRouteInput {
  kind: string;
  action?: string | null;
  clientEmployeeId?: string | null;
}

export function routeFromNotification(n: NotificationRouteInput): RouteLocationRaw {
  if (n.kind === "REPORT_READY") {
    return { path: "/reports" };
  }
  // Podsjetnik iz napomene vodi na zaposlenika; board-only napomena nema clientEmployeeId, pa je
  // grana ispod ionako salje na listu zaposlenika.
  if (n.kind === "EMPLOYEE_NOTE_REMINDER" && n.clientEmployeeId) {
    return { path: `/client-employees/${n.clientEmployeeId}` };
  }
  // EMPLOYEE_IMPORT_UNDONE never carries a clientEmployeeId (the employees it refers to no longer
  // exist), so it already falls through the generic !clientEmployeeId branch to the employee list.
  // Zaposlenika više nema, pa ga nema ni gdje otvoriti — obavijest sa svim detaljima (ime, radnja,
  // poruka Vomi korisnika) živi na naslovnici, i to je ono što korisnik klikom traži. Grana mora
  // stajati prije provjere ispod, koja bi ovu vrstu bez clientEmployeeId-a poslala na listu.
  if (n.kind === "EMPLOYEE_HARD_DELETED") {
    return { path: "/" };
  }
  if (n.kind === "EMPLOYEE_IMPORT_COMPLETED" || !n.clientEmployeeId) {
    return { path: "/client-employees" };
  }
  // EMPLOYEE_CREATED_BY_VOMI is intentionally handled by the fallthrough below: it always carries a
  // clientEmployeeId and isn't contract-related, so it lands on the new employee's profile.
  const contractRelated =
    n.kind === "CONTRACT_EXPIRING" ||
    (n.action !== "ODJAVA" &&
      (n.kind === "DOCUMENT_READY" || n.kind === "ANNEX_READY" || n.kind === "TASK_COMPLETED"));
  return {
    path: `/client-employees/${n.clientEmployeeId}`,
    query: contractRelated ? { tab: "contract" } : undefined,
  };
}
